import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as FundingActions from './funding.actions';
// import * as FundingFeature from './funding.reducer';
import * as FundingSelectors from './funding.selectors';
import { BehaviorSubject, Observable, take } from 'rxjs';
import {
  IDebitCreditCard,
  IDepositMoneyPak,
  IDepositCryptoCurrency,
  IDepositDebitCreditCard,
  IWithdrawDebitCreditCard,
  IWithdrawCheckByEmail,
  IDepositPromoCode,
  IOnlineCheckACH,
  IAccountACH
} from './funding.models';
import { ITransactionFeeResponse, TError } from '@amwager/util-ts';

@Injectable()
export class FundingFacade {
  private readonly store = inject(Store);
  private _isEProtectURLLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
  //  */
  // loaded$ = this.store.pipe(select(FundingSelectors.selectFundingLoaded));
  // allFunding$ = this.store.pipe(select(FundingSelectors.selectAllFunding));
  // selectedFunding$ = this.store.pipe(select(FundingSelectors.selectEntity));

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  // init() {
  //   this.store.dispatch(FundingActions.initFunding());
  // }

  isError$(): Observable<TError> {
    return this.store.pipe(select(FundingSelectors.getFundingError));
  }

  // deposit debit credit card
  depositDebitCreditCard(amount: number, orderId?: string, tmsId?: string): void {
    this.store.dispatch(FundingActions.depositDebitCreditAPI({ amount, orderId, tmsId }));
  }

  depositDebitCreditCard$(): Observable<IDepositDebitCreditCard | undefined> {
    return this.store.pipe(select(FundingSelectors.getDepositDebitCreditCard));
  }

  isDepositDebitCreditCardProcessing$(): Observable<boolean | undefined> {
    return this.store.pipe(select(FundingSelectors.getIsDepositDebitCreditCardProcessing));
  }

  isDepositDebitCreditCardSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.getIsDepositDebitCreditCardSuccess));
  }

  // withdraw debit credit card
  withdrawDebitCreditCard(amount: number, orderId?: string, tmsId?: string): void {
    this.store.dispatch(FundingActions.withdrawDebitCreditAPI({ amount, orderId, tmsId }));
  }

  withdrawDebitCreditCard$(): Observable<IWithdrawDebitCreditCard | undefined> {
    return this.store.pipe(select(FundingSelectors.getWithdrawDebitCreditCard));
  }

  isWithdrawDebitCreditCardProcessing$(): Observable<boolean | undefined> {
    return this.store.pipe(select(FundingSelectors.getIsWithdrawDebitCreditCardProcessing));
  }

  isWithdrawDebitCreditCardSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.getIsWithdrawDebitCreditCardSuccess));
  }


  /**
   * Get debit credit card
   */
  getDebitCreditCard(): void {
    this.store.dispatch(FundingActions.getDebitCreditAPI());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getListCards$(): Observable<any> {
    return this.store.pipe(select(FundingSelectors.getListCards));
  }

  // getListCards$(): Observable<{
  //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   response: any,
  // }> {
  //   return this.store.select(FundingSelectors.getListCards);
  // }

  /**
   * Add debit credit card
   */
  addDebitCreditCard(
    card: IDebitCreditCard
  ): void {
    this.store.dispatch(FundingActions.addDebitCreditAPI({
      card
    }));
  }

  isAddDebitCreditCardSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.addCardSuccess));
  }

  /**
   * Delete debit credit card
   */
  deleteDebitCreditCard(orderId: string): void {
    this.store.dispatch(FundingActions.deleteDebitCreditAPI({ orderId }));
  }

  isDeleteDebitCreditCardSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.deleteCardSuccess));
  }

  getCardFee$(): Observable<ITransactionFeeResponse | undefined> {
    return this.store.pipe(select(FundingSelectors.cardFee));
  }

  // deposit promo code
  depositPromoCode(promoCode: string): void {
    this.store.dispatch(FundingActions.depositPromoCodeAPI({ promoCode }));
  }
  depositPromoCode$(): Observable<IDepositPromoCode | undefined> {
    return this.store.pipe(select(FundingSelectors.getDepositPromoCode));
  }
  isDepositPromoCodeProcessing$(): Observable<boolean | undefined> {
    return this.store.pipe(select(FundingSelectors.getIsDepositPromoCodeProcessing));
  }
  isDepositPromoCodeSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.getIsDepositPromoCodeSuccess));
  }

  // deposit moneypak
  depositMoneyPak(moneyPakNumber: string): void {
    this.store.dispatch(FundingActions.depositMoneyPakAPI({ moneyPakNumber }));
  }
  depositMoneyPak$(): Observable<IDepositMoneyPak | undefined> {
    return this.store.pipe(select(FundingSelectors.getDepositMoneyPak));
  }
  isDepositMoneyPakProcessing$(): Observable<boolean | undefined> {
    return this.store.pipe(select(FundingSelectors.getIsDepositMoneyPakProcessing));
  }
  isDepositMoneyPakSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.getIsDepositMoneyPakSuccess));
  }

  // deposit crypto currency
  depositCryptoCurrency(amount: number): void {
    this.store.dispatch(FundingActions.depositCryptoCurrencyAPI({ amount }));
  }

  depositCryptoCurrency$(): Observable<IDepositCryptoCurrency | undefined> {
    return this.store.pipe(select(FundingSelectors.getDepositCryptoCurrency));
  }

  isDepositCryptoCurrencyProcessing$(): Observable<boolean | undefined> {
    return this.store.pipe(select(FundingSelectors.getIsDepositCryptoCurrencyProcessing));
  }

  isDepositCryptoCurrencySuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.getIsDepositCryptoCurrencySuccess));
  }

  /**
     * Get funding limit
     */
  getFundingLimit(): void {
    this.store.dispatch(FundingActions.getFundingLimitAPI());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFundingLimitList$(): Observable<any> {
    return this.store.pipe(select(FundingSelectors.getFundingLimitList));
  }

  addPendingAch(pendingDeposit: any, successResponse: any): void {
    this.store.dispatch(FundingActions.addPendingAch({ pendingDeposit, successResponse }));
  }

  /**
     * Get pending deposit ach
     */
  getPendingAch(): void {
    this.store.dispatch(FundingActions.getPendingAchAPI());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPendingAchList$(): Observable<any> {
    return this.store.pipe(select(FundingSelectors.getPendingAchList));
  }

  // deposit online check
  depositOnlineCheck(amount: number, bankAccountId: string | number, tmsId?: string): void {
    this.store.dispatch(FundingActions.depositOnlineCheckAPI({ amount, bankAccountId, tmsId }));
  }
  depositOnlineCheck$(): Observable<IOnlineCheckACH | undefined> {
    return this.store.pipe(select(FundingSelectors.getDepositOnlineCheck));
  }
  isDepositOnlineCheckProcessing$(): Observable<boolean | undefined> {
    return this.store.pipe(select(FundingSelectors.getIsDepositOnlineCheckProcessing));
  }
  isDepositOnlineCheckSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.getIsDepositOnlineCheckSuccess));
  }

  /**
     * Get account ach
     */
  getAchAccount(): void {
    this.store.dispatch(FundingActions.getAchAccountAPI());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAchAccountList$(): Observable<any> {
    return this.store.pipe(select(FundingSelectors.getAchAccountList));
  }

  /**
   * Add account ach
   */
  addAccountACH(
    account: IAccountACH
  ): void {
    this.store.dispatch(FundingActions.addAchAccountAPI({
      account
    }));
  }

  isAddAchAccountSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.addAchAccountSuccess));
  }

  /**
   * Delete account ach
   */
  deleteAchAccount(accountId: string | number): void {
    this.store.dispatch(FundingActions.deleteAchAccountAPI({ accountId }));
  }

  isDeleteAchAccountSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.deleteAchAccountSuccess));
  }

  // withdraw check by email
  withdrawCheckByEmail(method: string, amount: number): void {
    this.store.dispatch(FundingActions.withdrawCheckByEmailAPI({ method, amount }));
  }

  withdrawCheckByEmail$(): Observable<IWithdrawCheckByEmail | undefined> {
    return this.store.pipe(select(FundingSelectors.getWithdrawCheckByEmail));
  }

  isWithdrawCheckByEmailProcessing$(): Observable<boolean | undefined> {
    return this.store.pipe(select(FundingSelectors.getIsWithdrawCheckByEmailProcessing));
  }

  isWithdrawCheckByEmailSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.getIsWithdrawCheckByEmailSuccess));
  }

  // withdraw online check
  withdrawOnlineCheck(amount: number, bankAccountId: string | number, tmsId?: string): void {
    this.store.dispatch(FundingActions.withdrawOnlineCheckAPI({ amount, bankAccountId, tmsId }));
  }
  withdrawOnlineCheck$(): Observable<IOnlineCheckACH | undefined> {
    return this.store.pipe(select(FundingSelectors.getWithdrawOnlineCheck));
  }
  isWithdrawOnlineCheckProcessing$(): Observable<boolean | undefined> {
    return this.store.pipe(select(FundingSelectors.getIsWithdrawOnlineCheckProcessing));
  }
  isWithdrawOnlineCheckSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(FundingSelectors.getIsWithdrawOnlineCheckSuccess));
  }

  /**
   * @param sourceInitiator The source component where the method was first invoked.
   *
   * @usageNotes
   *  important: don't initialized multiple times
   *
   * ### Example:
   *
   */
  initState(sourceInitiator: string): void {
    this.store.select(FundingSelectors.getFundingLoaded)
      .pipe(take(1))
      .subscribe(isLoaded => {
        isLoaded
          ? null
          : this.store.dispatch(FundingActions.initFundingState({ sourceInitiator }))
      });
  }
  clearState(sourceInitiator: string): void {
    this.store.dispatch(FundingActions.clearFundingState({ sourceInitiator }));
  }

  setError(error: TError): void {
    this.store.dispatch(FundingActions.setError({ error }));
  }

  //cards
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setCards(cards: any): void {
    return this.store.dispatch(FundingActions.setCards({ cards }));
  }

  // eprotect
  // setEProtectURLLoaded(truthy: boolean): void {
  //   this._isEProtectURLLoaded.next(truthy);
  // }

  // isEProtectURLLoaded(): Observable<boolean> {
  //   return this._isEProtectURLLoaded.asObservable();
  // }


  setCardFee(isDeposit: boolean, amount: number, method?: string): void {
    return this.store.dispatch(FundingActions.getTransactionFeeAPI({
      method, isDeposit, amount
   }));
  }
}
